
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/stories",
      function () {
        return require("private-next-pages/blogs/stories/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/stories"])
      });
    }
  